<template>
  <b-sidebar
    :id="'sidebar-right-' + review.id"
    :title="review.title"
    sidebar-class="bb-offcanvas-panel"
    bg-variant="white"
    :width="'100vw'"
    right
    backdrop-variant="dark"
    backdrop
    shadow
  >
    <template #header="{ hide }">
      <div class="review-sidebar__header">
        <span class="review-sidebar__title">
          {{ review.title }}
        </span>

        <button
          type="button"
          class="review-sidebar__close"
          @click="hide"
          aria-label="Cerrar"
        >
          <span style="margin-right: 2px">Cerrar</span>
          <i class="isax isax-close-circle"></i>
        </button>
      </div>
    </template>

    <div class="container-fluid mb-4 mt-2">
      <div class="row d-flex flex-wrap info-description">
        <div class="col">
          <div class="container info-description-right">
            <!--Titulo Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.title") }}: </strong>
              </div>
              <div class="col-8">
                <span>
                  {{ review.title }}
                </span>
              </div>
            </div>
            <!--Titulo Asignatura-->
            <div class="row">
              <div class="col-4">
                <strong> {{ $t("context.subject") }} :</strong>
              </div>
              <div class="col-8">{{ this.jwtContextTitle() }}</div>
            </div>
            <!--Organizador Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.organaizer") }}: </strong>
              </div>

              <div class="col-8">
                <span>{{
                  organaizer ? organaizer.fullName : $t("reviews.no_organaizer")
                }}</span>
              </div>
            </div>
            <!--Grupos Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.groups") }} </strong>
              </div>
              <div class="col-8">
                <span>{{ groupList() }}</span>
              </div>
            </div>
            <!--Estado Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.state") }}: </strong>
              </div>
              <div class="col-8">
                <span class="date">
                  <span v-if="isOngoing(review)">
                    <span v-if="review.endDate">
                      {{ $t("reviews.inprogress") }}
                    </span>
                    <span v-if="!review.endDate">
                      {{ $t("reviews.inprogress") }}
                    </span>
                  </span>
                  <span v-if="!isOngoing(review)">
                    <span
                      class="session-not-started text-cancel"
                      v-if="review.isCancel"
                    >
                      {{ $t("reviews.isCanceled") }}
                    </span>
                    <span
                      class="session-not-started"
                      v-else-if="notYetStarted(review) && review.endDate"
                    >
                      {{ $t("reviews.notstarted") }}
                    </span>
                    <span
                      class="session-not-started"
                      v-else-if="hasEnded(review)"
                    >
                      <span class="session-ended">
                        {{ $t("reviews.finished") }}
                      </span>
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <!--Descripcion Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.description") }}: </strong>
              </div>
              <div class="col-8">
                <span>{{ review.description }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="container">
            <!--Fecha Incio Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.begin") }}: </strong>
              </div>
              <div class="col-8 m-auto">
                <span>{{ formattedDate(review.startDate) }}</span>
              </div>
            </div>
            <!--Fecha Fin Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.finish") }}: </strong>
              </div>
              <div class="col-8 m-auto">
                <span>{{ formattedDate(review.endDate) }}</span>
              </div>
            </div>
            <!--Fecha Incio Inscripcion Revision-->
            <div class="row" v-if="review.signupStartDate">
              <div class="col-4">
                <strong>{{ $t("reviews.signup_begin") }}: </strong>
              </div>
              <div class="col-8 m-auto">
                <span>{{ formattedDate(review.signupStartDate) }}</span>
              </div>
            </div>
            <!--Fecha Fin Inscripcion Revision-->
            <div class="row" v-if="review.signupEndDate">
              <div class="col-4">
                <strong>{{ $t("reviews.signup_finish") }}: </strong>
              </div>
              <div class="col-8 m-auto">
                <span>{{ formattedDate(review.signupEndDate) }}</span>
              </div>
            </div>
            <!--Ubicacion de la Revision-->
            <div class="row">
              <div class="col-4">
                <strong>{{ $t("reviews.location") }}: </strong>
              </div>
              <div class="col-5">
                <p class="truncate-text">
                  <span
                    :id="'copy-url-' + review.id"
                    class="location"
                    ref="location"
                    >{{ review.location }}
                  </span>
                </p>
              </div>
              <div class="col-3">
                <button class="copy-location" @click="copy">
                  <b-icon-files></b-icon-files>
                  <span v-show="isCopy">{{ $t("general.copy") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="signup-advice" v-show="isSignup">
      <p>
        <b-icon-info-circle-fill />
        <strong>{{ $t("context.advice-title") }}: </strong
        >{{ $t("context.advice-text") }}
      </p>
    </div>
    <IntervalTable
      :review="review"
      :key="key"
      @refreshtable="refreshtable"
      @changeSubcription="changeSubcription"
      v-if="
        review.intervalList.length != null && review.intervalList.length > 0
      "
    />
  </b-sidebar>
</template>
<script>
import UsersService from "@/service/users.js";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import jwtMixin from "@/mixins/jwtMixin";
import { BIconFiles, BIconInfoCircleFill } from "bootstrap-vue";
import IntervalTable from "@/components/Lti/Modals/IntervalTable.vue";
import DateService from "@/service/dates";

export default {
  name: "InfoReviewSidebar",
  components: { IntervalTable, BIconFiles, BIconInfoCircleFill },
  // eslint-disable-next-line vue/no-unused-components
  mixins: [utilitiesMixin, jwtMixin],
  props: ["review"],
  created() {
    this.getOrganizer();
  },
  data() {
    return {
      isCopy: false,
      isSignup: false,
      organaizer: null,
      key: 1,
      startDateSignup: null,
      endDateSignup: null,
      userTimezone: DateService.getUserTimezone(),
    };
  },
  methods: {
    getOrganizer() {
      if (this.review) {
        let filterParams = new URLSearchParams();
        filterParams.append("id", this.review.organaizer);
        UsersService.getUsers(filterParams).then(
          (response) => (this.organaizer = response.data.results[0])
        );
      }
    },
    refreshtable() {
      this.key++;
    },
    changeSubcription(value) {
      this.isSignup = value;
    },
    copy() {
      this.isCopy = true;
      // crear elemento temporal para que se pueda usar el clipboard en todos los navegadores.
      const tempElement = document.createElement("textarea");
      tempElement.value = document.getElementById(
        "copy-url-" + this.review.id
      ).innerText;
      document.body.appendChild(tempElement);

      tempElement.select();
      document.execCommand("copy");

      // Limpia y elimina el elemento temporal
      document.body.removeChild(tempElement);
      setTimeout(() => {
        this.isCopy = false;
      }, 7000);
    },
    groupList() {
      let text = "";
      for (let gr of this.review.groupList) {
        if (gr) text += gr.name + ", ";
      }
      return text.slice(0, text.length - 2);
    },
    formattedDate(dateUtc) {
      return DateService.utcToEvent(
        dateUtc,
        this.userTimezone,
        "D/M/YY - HH:mm"
      );
    },
  },
};
</script>
